/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatProfileDisplay.vue?vue&type=template&id=52622ea8&scoped=true"
import script from "./ChatProfileDisplay.vue?vue&type=script&lang=js"
export * from "./ChatProfileDisplay.vue?vue&type=script&lang=js"
import style0 from "./ChatProfileDisplay.vue?vue&type=style&index=0&id=52622ea8&lang=css"
import style1 from "./ChatProfileDisplay.vue?vue&type=style&index=1&id=52622ea8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52622ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52622ea8')) {
      api.createRecord('52622ea8', component.options)
    } else {
      api.reload('52622ea8', component.options)
    }
    module.hot.accept("./ChatProfileDisplay.vue?vue&type=template&id=52622ea8&scoped=true", function () {
      api.rerender('52622ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatProfileDisplay.vue"
export default component.exports